import React, { useEffect, useState } from 'react';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import Sidebar from './Sidebar';
import JobApplicationsTable from './JobApplicationsTable';
import { toast } from 'react-toastify';
import { FaBars } from 'react-icons/fa';

const ViewJobApplication = () => {
  const [applications, setApplications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [applicationsPerPage] = useState(5);  // Adjust this as needed
  const firestore = getFirestore();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  
  const toggleSidebar = (state) => {
    setIsSidebarOpen(state);
  };


  // Fetch applications from Firestore
  const fetchApplications = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, 'applications'));
      const appsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setApplications(appsData);
    } catch (error) {
      console.error('Error fetching applications:', error);
      toast.error('Failed to load applications. Please try again later.');
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  // Calculate the applications to display on the current page
  const indexOfLastApp = currentPage * applicationsPerPage;
  const indexOfFirstApp = indexOfLastApp - applicationsPerPage;
  const currentApplications = applications.slice(indexOfFirstApp, indexOfLastApp);

  // Calculate total pages
  const totalPages = Math.ceil(applications.length / applicationsPerPage);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Handle next and previous page navigation
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  return (
    <div className="lg:flex h-screen overflow-hidden">
       <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className={`flex-1 overflow-y-auto transition-all duration-300 lg:mt-2 mt-10 
          ${isSidebarOpen ? "ml-56 p-2 mr-[-16px] " : "lg:ml-20 sm:ml-2 lg:p-8 sm:p-6"}`}  
        >
      <h1 className="text-2xl font-[500] mb-6">Job Application</h1>
        {applications.length > 0 ? (
          <>
            <JobApplicationsTable applications={currentApplications} />
            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 space-x-2">
              <button
                onClick={handlePrev}
                disabled={currentPage === 1}
                className="px-4 py-2 border rounded-lg transition duration-200"
                style={{
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                Prev
              </button>
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={`px-4 py-2 border rounded-lg transition duration-200 ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-white text-blue-500 hover:bg-blue-100'}`}
                >
                  {index + 1}
                </button>
              ))}
              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className="px-4 py-2 border rounded-lg transition duration-200"
                style={{
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              >
                Next
              </button>
            </div>
          </>
        ) : applications.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-40 text-gray-600">
            <p className="text-lg font-medium">No job applications available.</p>
            <p className="text-sm">Check back later for updates.</p>
          </div>
        ) : (
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid"></div>
            <p className="ml-3 text-gray-600">Fetching job applications...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewJobApplication;
